import React from 'react';
import classes from './GarageContent.module.scss';
import { formatDay } from '../../services/dealerGarage';

/**
 * The step history of a purchase or inspection, oldest first so it reads
 * top to bottom like the progress tracker above it. The last entry is where
 * the record stands now. A step's `note` is a message from the team written
 * for the customer, so it is shown in full.
 *
 * `showLatestNote={false}` leaves out the last step's note, for a card that
 * already shows it beside the current status.
 */
const StatusTimeline = ({ history, showLatestNote = true }) => {
    const entries = Array.isArray(history) ? history : [];
    if (entries.length === 0) return null;

    return (
        <ol className={classes.timeline}>
            {entries.map((entry, i) => {
                const latest = i === entries.length - 1;
                return (
                    <li key={`${entry.status}-${i}`} className={latest ? classes.timelineCurrent : ''}>
                        <span className={classes.timelineDot} aria-hidden="true"></span>
                        <span className={classes.timelineStatus}>{entry.status}</span>
                        <span className={classes.timelineDate}>{formatDay(entry.at)}</span>
                        {entry.note && (showLatestNote || !latest) && (
                            <span className={classes.timelineNote}>{entry.note}</span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
};

export default StatusTimeline;
